import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-public-patient-reminders',
  templateUrl: './public-patient-reminders.component.html',
  styleUrls: ['./public-patient-reminders.component.scss']
})
export class PublicPatientRemindersComponent implements OnInit {

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0)
      }
    });
  }

  ngOnInit(): void {
  }

}
